(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.FIGTraining",
            {
                url: "/FIGTraining",
                component: "figtraining",
                PageTitle: "Carrier and Annuity Training",
                requiredPermissions: "FigTraining:View",
                resolve: {
                    states: ["states", function (states) {
                        return states;
                    }]
                }
            });
        }
    ]);

    app.component("figtraining",
    {
        templateUrl: "App/Resources/FIGTraining/FIGTraining.html",
        controller: figTrainingCtrl,
        bindings: {
            states: "<"
        }
    });

    figTrainingCtrl.$inject = ["amplitudeService"];

    function figTrainingCtrl(amplitudeService) {

        var $ctrl = this;
        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
        
    }
    
})(window.app, window.angular); // jshint ignore:line